import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { GET_ORDER, GET_ORDERS_BY_FILTER, CLEAR_ORDERS, GET_RELATED_ORDERS } from "../constants/action-types";


const API_CONFIG = getApiConfig();

/* 
    Get Order
*/

export const getOrder = (orderId, callback) => dispatch => {

    adalApiFetch(Axios, `${API_CONFIG.URL}/orders/${orderId}`, {
        method: "get"
    }).then(res => {
        dispatch({
            type: GET_ORDER,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    });
};

/* 
    Get Orders by Filter
*/

export const getOrdersByFilter = (filter, callback) => dispatch => {

    adalApiFetch(Axios, `${API_CONFIG.URL}/orders?byFilter=true`, {
        method: "post",
        data: filter
    }).then(res => {
        dispatch({
            type: GET_ORDERS_BY_FILTER,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error.message}`);
        callback(false);
    })
};

export const clearOrders = (callback) => dispatch => {

    dispatch({
        type: CLEAR_ORDERS,
        payload: null
    });
    callback(true);

};

export const getRelatedOrders = (orderId, callback) => dispatch => {

    adalApiFetch(Axios, `${API_CONFIG.URL}/orders/${orderId}`, {
        method: "get"
    }).then(res => {

        dispatch({
            type: GET_RELATED_ORDERS,
            payload: { ...res.data, orderId }
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    });
};